<template>
  <div class="works-rules">
    <div class="rule_list rule_list_1">
      <ul>
        <li>每件作品作者限3人以内，可配1名指导教师。请确认作者及指导教师姓名填写准确无误，最终获奖人员姓名将以填写信息为准。</li>
      </ul>
    </div>
    <div class="rule_list rule_list_2">
      <ul>
        <li class="rule_list_icon"><var>1.</var>个人（团队）自荐</li>
        <li class="rule_list_icon"><var>2.</var>教育部直属高校及部省合建高校推荐</li>
        <li class="rule_list_icon"><var>3.</var>省级教育工作部门推荐</li>
        <li>同一作品仅可通过以上三种方式之一参与活动，重复推荐的视为放弃参与资格。</li>
      </ul>
    </div>
    <div class="rule_list rule_list_3">
      <ul>
        <li>作品须积极、健康、向上，传承中华美德，弘扬中国精神，用简洁朴实、清新爽朗、积极向上、充满活力的语言来分享成长感悟、定格青春记忆，传递真善美，践行社会主义核心价值观，展示改革开放成果。</li>
        <li>作品可以是诵读作品、创意音频或有声故事。鼓励学生选取原创作品进行参与。</li>
        <li>诵读作品是指：以朗读或朗诵形式进行呈现的音频作品</li>
        <li>创意音频是指：通过创新手法制作的音频内容，创新手法包括但不限于声音艺术、实验音乐、广播剧等。</li>
        <li>有声故事是指：将书籍内容通过朗读或配音方式录制成音频的作品。</li>
      </ul>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "AudioWorkRules",
};
</script>

<style scoped lang="scss">
@use "@/styles/vars";

.works-rules {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 30px;
  width: 1050px;
}
.rule_list{
  padding-left: 220px;
  line-height: 180%;
  min-height: 36px;
}
.rule_list li{
  list-style: none;
  margin-bottom: 4px;
}
.rule_list li var{
  display: inline-block;
  width: 29px;
  text-align: center;
  font-style: normal;
}
.rule_list_1{
  background: url('~@/assets/msg_tit_1.png') no-repeat;
}
.rule_list_2{
  background: url('~@/assets/msg_tit_2.png') no-repeat;
}
.rule_list_3{
  background: url('~@/assets/msg_tit_3.png') no-repeat;
}
.rule_list_4{
  background: url('~@/assets/msg_tit_4.png') no-repeat;
}
.rule_list_icon{
  background: url('~@/assets/icon_2.png') 0 1px no-repeat;
}
.rule-item {
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 5px;
  position: relative;
}

.rule-num {
  position: absolute;
  top: 10px;
  left: 10px;
  color: vars.$primary-color;
  font-weight: bold;
}

.rule-item h3 {
  margin-left: 30px;
  margin-bottom: 10px;
  color: #333;
}

.rule-item p {
  color: #666;
  margin-bottom: 5px;
}

.rule-item ol {
  padding-left: 20px;
  color: #666;
}
</style>